<script>
    import { mapState} from 'vuex'
    export default{
        computed: {
            ...mapState({
                user: 'user',
            })
        },
    }
</script>

<template>
    <div class="mag-header-user">
        <i class="mag-icon-nav-top-user"></i>
        <span>
            {{user.name}} {{user.fullName}} ({{user.departmentName}})
        </span>
    </div>
</template>

<style lang="scss">
    .mag-header-user{
        padding: 0 8px;
        display: flex;
        align-items: center;
        span{
            padding: 0 0 0 8px;
            font-size: 13px;
        }
        i{
            font-size: 20px;
        }
    }
</style>
